(ns app.front.view.search.list-view
  "List (table) view of the search page tabs that are backed by `app.front.dashboard.search`.

  The rows come from Elasticsearch one page at a time, so both paging and sorting are done by
  the backend: the table only renders the already loaded page, 'show more' fetches the next one
  and a click on a sortable header re-queries the whole result set with a new sort condition."
  (:require [app.front.dashboard.search :as search]
            [app.front.ui.sortable-table :as sortable-table]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]))

(defn- on-sort-hook [attribute previous-sort-order]
  (>evt [::search/set-sort-condition [attribute (if (= previous-sort-order :asc) :desc :asc)]]))

(defn sortable-col
  "Column options that make a header clickable for the attributes the backend can sort by.

  The table disables local row sorting; `:on-sort-hook` re-queries the whole result set."
  [sort-options attribute]
  (when (some #(= attribute (first %)) sort-options)
    {:sort-key     attribute
     :sorting      true
     :on-sort-hook (partial on-sort-hook attribute)}))

(defn- table-id [search-mode]
  (str "search-" (name (:name search-mode)) "-list"))

(defn list-results
  "Result table of a search tab, built from the tab's `:list-view-cols`, `:list-view-link` and
  `:list-view-row-click`. A mode whose results have no href to open, e.g. the complaint modal,
  leaves `:list-view-link` out and opens them with `:list-view-row-click` instead.
  Optional `:list-view-actions` provide expandable row actions. Paging controls follow the table."
  [tr {:keys [list-view-cols list-view-link list-view-actions id-fn] :as search-mode}]
  (let [opts {:tr           tr
              :lang         (<sub [:language])
              :format-date  (<sub [::date-util/date-fn])
              :val->str-fn  (<sub [::search/val->str-fn])
              :sort-options (:sort-options (<sub [::search/search-config]))}]
    (if (<sub [::search/has-results?])
      [:<>
       [sortable-table/table
        {:id             (table-id search-mode)
         :cols           (list-view-cols opts)
         :items          (:results (<sub [::search/result]))
         :sort-items?    false
         :id-func        id-fn
         :link           (when list-view-link (list-view-link opts))
         :on-row-click   (:list-view-row-click search-mode)
         :make-actions   (when list-view-actions (partial list-view-actions opts))
         :configurable?  true
         :sticky-header? true
         :tr             tr}]
       [search/back-to-top-button tr]
       [search/load-more tr]]
      [search/results-placeholder tr])))
